export const subscriptionIdParamName = 'esid';
export const invitationTokenParamName = 'it';
export const userRegistrationCompletedParamName = 'urc';
export const REGISTER_RESEND_COOLDOWN_STORAGE_KEY =
  'register_resend_cooldown_end';

import type { TestimonialItem } from '@hostfully/ui-components';

// TODO: replace placeholder testimonials
export const REGISTER_TESTIMONIALS: TestimonialItem[] = [
  {
    id: '1',
    photo: 'https://i.pravatar.cc/240?img=47',
    photoAlt: 'Lorem Garcia',
    mainText: 'My team saves tons of time using Hostfully Products',
    title: 'Lorem Garcia',
    subtitle: 'Florida Vacation Pads',
  },
  {
    id: '2',
    photo: 'https://i.pravatar.cc/240?img=12',
    photoAlt: 'Jane Doe',
    mainText:
      'Hostfully boosted our occupancy rate and centralized our operations.',
    title: 'Jane Doe',
    subtitle: 'Sunny Coast Rentals',
  },
  {
    id: '3',
    photo: 'https://i.pravatar.cc/240?img=33',
    photoAlt: 'John Smith',
    mainText: 'Best PMS we have ever used. Onboarding was a breeze.',
    title: 'John Smith',
    subtitle: 'Mountain Stays Co.',
  },
];
